import { apiRequest } from "utils/api";
import { persistor, AppDispatch } from "store";
import {
  CREATE_SESSION_FAILURE,
  CREATE_SESSION_SUCCESS,
  DELETE_SESSION_SUCCESS,
  RENEW_ROLE_SUCCESS,
  RENEW_ROLE_FAILURE,
  CreateSessionData,
} from 'store/reducers/session/types';

export const purgePersistor = (): void => {
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
  persistor.persist();
};

export const createSession = (data: CreateSessionData): any => {
  return async (dispatch: AppDispatch) => {
    if (!data) {
      dispatch({ type: CREATE_SESSION_FAILURE });
    }

    try {
      const response = await apiRequest("post", "auth/get-access-token", {
        data: { ...data },
      }, false);

      dispatch({
        type: CREATE_SESSION_SUCCESS,
        contents: response?.data,
      });

      localStorage.setItem("accessToken", response?.data.accessToken);
      localStorage.setItem("refreshToken", response?.data.refreshToken);

      return response?.data || {};
    } catch (response: any) {
      dispatch({ type: CREATE_SESSION_FAILURE });
      localStorage.removeItem("accessToken");
      throw response;
    }
  };
};

export const renewAccessToken = (): any => {
  return async (dispatch: AppDispatch) => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      dispatch({ type: CREATE_SESSION_FAILURE });
    }

    try {
      const response = await apiRequest("post", "auth/renew-access-token", {
        data: { refreshToken },
      }, false);

      purgePersistor();

      const { accessToken: newAccessToken } = response?.data;

      if (newAccessToken) {
        localStorage.setItem("accessToken", newAccessToken);
      }

      return response?.data || {};
    } catch (response: any) {
      dispatch({ type: CREATE_SESSION_FAILURE });
      throw response;
    }
  };
};

export const deleteSession = (): any => {
  return (dispatch: AppDispatch) => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    //purgePersistor()

    dispatch({ type: DELETE_SESSION_SUCCESS });
  };
};

export const renewRole = (): any => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await apiRequest('get', 'auth/renew-session');

      dispatch({
        type: RENEW_ROLE_SUCCESS,
        contents: response?.data,
      });

      localStorage.setItem("accessToken", response?.data.accessToken);
      localStorage.setItem("refreshToken", response?.data.refreshToken);

      return window.location.reload();
    } catch (response: any) {
      if (response && response.error) {
        dispatch({
          type: RENEW_ROLE_FAILURE,
          error: response.error
        });
      }

      throw response;
    }
  };
};
